/* eslint-disable array-callback-return */
import { Dialog, DialogContent, DialogTitle, ListItemText, TextField } from "@material-ui/core"
import FormacionDesarolloContext from "../../../context/FormacionDesarollo/FormacionDesarrolloContext"
import { useContext, useEffect, useRef, useState } from "react"
import { Checkbox, CircularProgress, Fade, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { clearCoursesModal, createUserCourseModal } from "../../../context/FormacionDesarollo/FormacionDesarrolloActions";
import Add from "../../../assets/svg/addPrestacion.svg"
import "../css/ModalCreateCurso.css"
import DateRangeFieldSV from "../../MyMood/Fields/DateRangeFieldSV";
import UploadImage from "../../../assets/svg/uploadImage.svg"
import Plus from "../../../assets/svg/plus.svg"
import BtnAddCompetenciesCourse from "../components/BtnAddCompetenciesCourse";
import { GET_ALL_COMPETENCE_EVALUATION,
        GET_ALL_COURSES,
        GET_ALL_SEDE, GET_ALL_PROJECT, 
        GET_ALL_COURSES_BY_ID, 
        DELETE_IMG_CURSO,
        UPDATE_COURSE_INFO } from "../../../Querys/querys";
import { GET_USERS_BY_CAMPUS_OR_PROJECT } from "../../../Querys/prestaciones/querys";
import { Form } from "semantic-ui-react"
import { postFileCloudCurso } from "../../../services/candidateService";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import Minus from '../../../assets/svg/minus.svg'
import { useFormik } from "formik";
import * as Yup from 'yup'
import { addDays, format, subMonths } from "date-fns";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { ErrorAlert } from "../../../alerts/errorAlert";
import AdminColaboradoresCourses from "./AdminColaboradoresCourses";
import RemoveFile from '../../../assets/svg/remove_file.svg'

const UpdateCourse = ({setInfoImg}:any)=>{
    const {state, dispatch} = useContext(FormacionDesarolloContext)
    const [btnDisable, setBtnDisable] = useState<boolean>(false)
    const [txtImagen,setTxtImagen]=useState("Agregar imagen del curso")
    const [competencias, setCompetencias] = useState<Array<any>>([])
    const [archives, setArchives] = useState<any>("")
    const [addCompetencias, setAddCompetencias] = useState<Array<any>>([])
    const [selectedCompetency, setSelectedCompetency] = useState<string>('')
    const [evaluarCurso, setEvaluarCurso] = useState(false)
    const [selectedUser, setSelectedUser] = useState<String[]>([]);
    const [sedes, setSedes] = useState<any>([])
    const [projects, setProjects] = useState<any>([]);
    const inputRef:any = useRef(null)
    const [counterTxt, setCounterTxt] = useState(0)
    const {data: getAllSedes} = useQuery(GET_ALL_SEDE)
    const {data: getAllProjects} = useQuery(GET_ALL_PROJECT)
    const [getUserByCampusProject ] = useLazyQuery(GET_USERS_BY_CAMPUS_OR_PROJECT);
    const resultSedes = getAllSedes?.GET_ALL_SEDE
    const resultProjects = getAllProjects?.GET_ALL_PROJECT
    const [selectedAllSedes, setSelectedAllSedes] = useState<String[]>([]);
    const [selectedAllProjects, setSelectedAllProjects] = useState<String[]>([]);
    const [delaultImg,setDefaultImg]=useState(true)
    const [usersByCampusProject, setUsersByCampusProject] = useState<Array<any>>([]);
    const [stateCalendario, setStateCalendario] = useState([
        {
          startDate: subMonths(new Date(), 0),
          endDate: addDays(new Date(), 0),
          key: "selection"
        }]
      );
      const [startDate, setStartDate] = useState(subMonths(new Date(), 0).toString());
      const [endDate, setEndDate] = useState(addDays(new Date(), 0).toString());  
    const { data: resultCompetencies} = useQuery(GET_ALL_COMPETENCE_EVALUATION)
    const allCompetencies = resultCompetencies?.GET_ALL_COMPETENCE_EVALUATION
    const [colaboradoresBD,setColaboradoresBD]=useState<Array<any>>([]);
    const [loadingFade, setLoadingFade] = useState(false);
    const [temario, setTemario] = useState<Array<string>>([])
    const [respImg, setResImg] = useState({})
    const [cursos, setCursos] = useState<Array<any>>([])
    const [initialValuesForm, setInitialValuesForm] = useState({
        title: "",
        instructor: "",
        hours: "",
        description: "",
        competencias: "",
        Image: '',
        sede: "",
        area: "",
    })
    const { data: getCursoById, loading } = useQuery(GET_ALL_COURSES_BY_ID, {
        variables: { id: state._id },
        fetchPolicy: 'no-cache'
    })

    const [updateCourse] = useMutation(UPDATE_COURSE_INFO, {
        refetchQueries: [{ query: GET_ALL_COURSES }],
    })

    useEffect(() => {
        if (getCursoById && getCursoById.GET_ALL_COURSES_BY_ID) {
            setCursos(getCursoById.GET_ALL_COURSES_BY_ID)
        }
    }, [getCursoById])

    const [DeleteImg] = useMutation(DELETE_IMG_CURSO, {
        refetchQueries: [
            { query: GET_ALL_COURSES }
        ],
      }); 

    useEffect(() => {
        if (state._id) {
            if (cursos.length > 0) {
                setCounterTxt(cursos[0]?.description.length)
                setEvaluarCurso(cursos[0]?.evaluar === 'true' ? true : false)
                setColaboradoresBD(cursos[0]?.usuarios)
                const arraySede: any = []
                cursos[0]?.sedes.map((sede:any) => {
                    arraySede.push(sede.sede)
                })
                setSelectedAllSedes(arraySede)
                const arrayProyecto: any = []
                cursos[0]?.areas.map((area:any) => {
                    arrayProyecto.push(area.area)
                })
                setSelectedAllProjects(arrayProyecto)
                setStartDate(addDays(new Date(parseInt(cursos[0]?.dateInit)), 1).toString())
                setEndDate(addDays(new Date(parseInt(cursos[0]?.dateEnd)), 1).toString());
                setStateCalendario([
                    {
                        startDate: addDays(new Date(parseInt(cursos[0]?.dateInit)), 1),
                        endDate: addDays(new Date(parseInt(cursos[0]?.dateEnd)), 1),
                        key: "selection"
                    }
                ]);
                if (cursos[0]?.imgDefault=== 'true') {
                    setTxtImagen('Agregar imagen del curso')
                    setArchives('')
                } else {
                    const splitUrl = cursos[0].URL.split('/')
                    const txtImg = splitUrl[splitUrl.length-1];
                    setTxtImagen(txtImg)
                }
                const competenceIDs = cursos[0]?.competencias.map((comp: any) => comp.idCompetencies);
                const filteredCompetencies = competencias.filter((comp: any) => competenceIDs.includes(comp.id));
                setAddCompetencias(filteredCompetencies)
                setInitialValuesForm({
                    title: cursos[0]?.title,
                    instructor: cursos[0]?.bussinesNameInstructor,
                    hours: cursos[0]?.hours,
                    description: cursos[0]?.description,
                    competencias: filteredCompetencies[0]?.nameCompetence || '',
                    Image: cursos[0]?.URL,
                    sede: arraySede,
                    area: arrayProyecto,
                })
                const temarios = cursos[0]?.temario.map((tema: any) => tema.temario)
                setTemario(temarios)
                setDefaultImg(cursos[0]?.imgDefault=== 'true'?true:false);
            }
        }
    }, [competencias, cursos, state._id])

    useEffect(() => {
        if (resultSedes) {
            setSedes(resultSedes)
        }
    }, [resultSedes])

    useEffect(() => {
        if (resultProjects) {
            setProjects(resultProjects)
        }
    }, [resultProjects])
    
    const validationSchema = () => {
        return {
            title: Yup.string()
               .trim()
               .required("El nombre del curso es requerido"),
            instructor: Yup.string()
               .trim()
               .required("El nombre del instructor es requerido"),
               hours: Yup.string()
               .required("La cantidad de horas es requerida")
               .matches(/^\d+(\.\d{1})?$/, 'Solo se permiten números y máximo un decimal')
               .typeError("Debe ser un número válido"),
            competencias: Yup.string()
               .required("Debes agregar al menos una competencia"),
            sede: Yup.array().required("Es necesario seleccionar una sede").test("sede", "Es necesario seleccionar una sede", function(value){
                if((value === undefined || value.length === 0)){
                    return false;
                }else{
                    return true;
                }
               }),       
            area: Yup.array().required("Es necesario seleccionar un área o proyecto").test("area", "Es necesario seleccionar un área o proyecto", function(value){
                if((value === undefined || value.length === 0)){
                    return false;
                }else{
                    return true;
                }
            }),
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValuesForm,
        validationSchema: Yup.object(validationSchema()),
        onSubmit: async (formData, { resetForm }) =>{
            if(selectedUser.length === 0) {setSelectedUser(colaboradoresBD)}
            if(selectedUser.length ===0 && colaboradoresBD.length === 0){
                ErrorAlert({text:'Es necesario agregar usuarios al curso'});
                return
            }
            if (addCompetencias.length === 0) {
                ErrorAlert({text:'Es necesario agregar competencias al curso'});
                return
            }
            let arrayUserSel:any=[];
            let objUserSel:{};
            selectedUser.map((selUser:any) => {
                objUserSel ={ id:selUser.id  }
                arrayUserSel.push(objUserSel)
            })
            const initDate: any = format(stateCalendario[0].startDate, 'yyyy-MM-dd')
            const endDate: any = format(stateCalendario[0].endDate, 'yyyy-MM-dd')
            const filteredTemario = temario.filter(item => item !== "")
            const courseData = {
                title: formData.title.trim(),
                description: formData.description.trim(),
                dateInit: initDate,
                dateEnd: endDate,
                hours: parseFloat(formData.hours),
                bussinesNameInstructor: formData.instructor.trim(),
                URL: '',
                usuarios:arrayUserSel,
                sede:selectedAllSedes,
                area:selectedAllProjects,
                evaluar: evaluarCurso ? 'true' : 'false',
                competencias: 
                    addCompetencias.map((competence, index) => ({
                        id: competence.id,
                    })),
                temarios:
                    filteredTemario.map((item, index) => ({
                        temario: item
                    }))
            };

            try {
                setBtnDisable(true)
                    await updateCourse({
                        variables: {
                            input: {...courseData, id: state._id}
                        }
                    })
                    if (archives !== '') {
                        const resImgUpd = await postFileCloudCurso(archives, state._id, "IMG_CURSO", "IMG_CURSO", false);
                        setResImg(resImgUpd)
                    }
                    await SuccessfulAlert({ text: "Curso actualizado correctamente." })
                setBtnDisable(false)
                closeModalEvalModel()
            } catch (error) {
                ErrorAlert({ text: 'Ocurrió un error al actualizar el curso.' })
                console.error(error);
                setBtnDisable(false)
            }
        }
    })

    const onChangeSede = (e:any) => {
        if (e.target.value.indexOf('Todas') > -1) {
            if(sedes.length === selectedAllSedes.length){
                setSelectedAllSedes([]);
                formik.setFieldValue('sede', '')
            }else{
                let filtered = sedes.map((item:any)=> item.sedeName);
                setSelectedAllSedes(filtered);
                formik.setFieldValue('sede', filtered)
            }
        } else {
            setSelectedAllSedes(e.target.value);
        }
    }

    const onChangeProject = (e:any) => {
        if (e.target.value.indexOf('Todas') > -1) {
          if (projects.length === selectedAllProjects.length) {
            setSelectedAllProjects([]);
            formik.setFieldValue('area', '')
          } else {
            let filtered = projects.map((item:any)=> item.proyectNameAndClient);
            setSelectedAllProjects(filtered);
            formik.setFieldValue('area', filtered)
          }
        } else {
            setSelectedAllProjects(e.target.value);      
        }
    }

    const handleAdminColaborador= async ()=>{
        if(selectedAllSedes.length === 0 || selectedAllProjects.length === 0 ){
              ErrorAlert({text:'Seleccione el Area y Sede'});
              return
            }else
            { 
             setUsersByCampusProject([])
             setLoadingFade(true)
             const proyectsName= selectedAllProjects.map((name:any)=>{
                const nameSplit=name.split('/');
                return nameSplit[0]
             })       
             let { data } = await getUserByCampusProject({
                  variables: { 
                      input: {
                          sede:selectedAllSedes,
                          projects:proyectsName
                         },
                      }
                  })   
                
                if(data.GET_USERS_BY_CAMPUS_OR_PROJECT.length>0){    
                    setUsersByCampusProject(data.GET_USERS_BY_CAMPUS_OR_PROJECT);            
                    setLoadingFade(false)
                    createUserCourseModal(true, dispatch)             
                 } else{
                  setLoadingFade(false)
                  ErrorAlert({text:'No hay colaboradores con los valores seleccionados'});
                 }  
               }       
            }

    useEffect(() => {
        if(Object.keys(respImg).length >0 ){
             setInfoImg(respImg)  
        }
    }, [respImg, setInfoImg]);  

    useEffect(() => {
        if (allCompetencies) setCompetencias(allCompetencies)
    }, [allCompetencies])

    useEffect(() => {
        if(resultCompetencies?.GET_ALL_COMPETENCE_EVALUATION){
        if (allCompetencies.length > 0 ) {
           
           const copyAllCompetencies=[...allCompetencies]
           let newArray = copyAllCompetencies.sort((x, y) => x.nameCompetence.localeCompare(y.nameCompetence));
           setCompetencias(newArray)
        }
      }
    }, [allCompetencies, resultCompetencies?.GET_ALL_COMPETENCE_EVALUATION])

    const onChangeImage = (e: any) => {
        setTxtImagen(e.target.files[0].name);
        setArchives(e.target.files[0]);
        if (!e.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
            ErrorAlert({ text: 'Debes seleccionar una imagen con formato.png, .jpg, .jpeg' })
            setTxtImagen('Agregar imagen del curso')
            setArchives('')
        }      
    }

    const onEliminaImage = async (e: any) => {
        const id= state._id;
        const  {data: res }= await DeleteImg ({
          variables: {
           id:id,                
          },
          }); 
          const resDelete=res?.DELETE_IMG_CURSO;
          if(resDelete ==="Imagen eliminada"){
            setDefaultImg(true)
            setTxtImagen("Agregar imagen del curso")
            setInfoImg([])
            setResImg({})
          }
        }

    const filteredCompetencies = competencias.filter(
        (competence: any) => !addCompetencias.some(comp => comp.id === competence.id),
    )

    const addCompetency = () => {
        if (selectedCompetency) {
            const competence = competencias.find(comp => comp.id === selectedCompetency);
            if (competence) {
                setAddCompetencias([...addCompetencias, competence]);
                setSelectedCompetency('');
            }
        }
    }

    const removeCompetency = (id: string) => {
        setAddCompetencias(prevAddedCompetencies => {
            const newAddedCompetencies = prevAddedCompetencies.filter(item => item.id !== id);
            if (newAddedCompetencies.length === 0) {
                formik.setFieldValue('competencias', '');
                setSelectedCompetency('')
            } else {
                // formik.setFieldValue('competencias', addCompetencias.find(comp => comp.id === id)?.nameCompetence)
                // setSelectedCompetency(addCompetencias.find(comp => comp.id === id)?.nameCompetence)
                const competence = addCompetencias.find(comp => comp.id === id);
                formik.setFieldValue('competencias', competence ? competence.id : '');
                setSelectedCompetency(competence ? competence.id : '');
            }
            return newAddedCompetencies;
            });
    }

    const isAddButtonDisabled = selectedCompetency?.length === 0 || filteredCompetencies.length === 0

    const addTemarioField = () => {
        setTemario([...temario, ""])
    }

    const handleTemarioChange = (index: number, value: string) => {
        const newTemario = [...temario];
        newTemario[index] = value;
        setTemario(newTemario);
    }

    const removeTemarioField = (index: number) => {
        const newTemario = temario.filter((_, i) => i !== index);
        setTemario(newTemario);
    };

    const counterCaracter = (e: any) => {
        setCounterTxt(e.length)
    }

    const closeModalEvalModel = () => {
        clearCoursesModal(false, dispatch)
        setCounterTxt(0)
        setAddCompetencias([])
        setTemario([])
        setSelectedCompetency('')
        setTxtImagen('Agregar imagen del curso')
        setEvaluarCurso(false)
        setResImg({})
        setArchives("")
        setSelectedAllSedes([]);
        setSelectedAllProjects([]);
        setSelectedUser([]);
        formik.resetForm()
    }

    return(
        <>
        {(loading === true) ? <></> 
        : <>
        <Dialog open={state.updateModalCourse}
            aria-labelledby="form-dialog-title"
            className="dialogCurso"
            disableEnforceFocus
        >
            <IconButton aria-label="close"
            onClick={(()=>{
                closeModalEvalModel()
            })}
            sx={{position:'absolute',
                right:8,
                top:8,
                color:(theme)=> theme.palette.grey[500]
            }}
            >
                <CloseIcon/>
            </IconButton>

            <DialogContent>
                <Form
                    onSubmit={formik.handleSubmit}
                >
                    <DialogTitle><span className="titleCurso">Actualizar Curso</span></DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Nombre del curso *"
                            name="title"
                            inputProps={{ maxLength: 50 }}
                            //fullWidth={true}
                            style={{ width: '99%'}}
                            variant="outlined"
                            size="small"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                            error={formik.touched.title && Boolean(formik.errors.title)}
                            helperText={formik.touched.title && formik.errors.title}
                        />
                    </DialogContent>
                    <DialogContent className="camposInLine">
                        <TextField
                            label="Instructor *"
                            name="instructor"
                            inputProps={{ maxLength: 50 }}
                            variant="outlined"
                            size="small"
                            style={{ width: "48%"}}
                            value={formik.values.instructor}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                            error={formik.touched.instructor && Boolean(formik.errors.instructor)}
                            helperText={formik.touched.instructor && formik.errors.instructor}
                        />

                        <TextField
                            label="Tiempo del curso (hrs)*"
                            name="hours"
                            variant="outlined"
                            size="small"
                            style={{ width: "48%"}}
                            value={formik.values.hours}
                            onChange={(e) => {
                                if (/^\d*\.?\d{0,1}$/.test(e.target.value)) {
                                  formik.handleChange(e);
                                }
                              }}
                            onBlur={formik.handleBlur}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                            error={formik.touched.hours && Boolean(formik.errors.hours)}
                            helperText={formik.touched.hours && formik.errors.hours}
                        />
                    </DialogContent>
                    <DialogContent>
                        <DateRangeFieldSV
                            setDate={setStateCalendario}
                            containerClass={"dateBorder"}
                            daySelected1={startDate}
                            daySelected2={endDate}
                            nameLabel={"Periodo"}  
                        />
                    </DialogContent>
                    <DialogContent style={{ paddingBottom: "0px"}}>
                        {delaultImg ? (
                        <label className="custom-file-upload-image">
                            <p className="txtInputImage">{txtImagen}</p>
                            <input
                                ref={inputRef}
                                type="file"
                                name="Image"
                                className="inputImage"
                                onChange={(e) => onChangeImage(e)}
                                accept=".png,.jpg,.jpeg"
                            />
                            <img id="imgCurso" src={UploadImage} alt="imgCurso"  />
                        </label> ) : (
                            <label className="custom-file-upload-image" id="lblImageDel">
                            <p className="txtInputImg"> {txtImagen }</p>
                           <img id="imgPrestacion" 
                                src={RemoveFile} 
                                alt="elimina"
                                width={40} 
                                height={40}  
                               onClick={(e) => onEliminaImage(e)}                            
                              /> 
                           </label> 
                        )
                        }
                    </DialogContent>
                    <DialogContent className="camposInLine">
                        <FormControl 
                            fullWidth 
                            size="small"
                            variant="outlined" 
                            className="question" 
                            style={{ minWidth: "48%", maxWidth: "120px" }}
                        >
                            <InputLabel id="demo-simple-select-label"  style={{backgroundColor: "#FFFFFF", width: "46px"}}>
                                Sede*
                            </InputLabel>
                            <Select
                                style={{                      
                                    fontFamily:'Roboto',
                                    fontStyle: 'italic',
                                    textOverflow: "ellipsis" ,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    //width:"212px",
                                    height:"40px"    
                                }}
                                value={selectedAllSedes}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    onChangeSede(e);
                                }}
                                labelId="demo-simple-select-label"
                                id="sede"
                                name = "sede"
                                multiple
                                renderValue={(selected:any) => selected.join(',')}
                                error={formik.touched.sede && Boolean(formik.errors.sede)}
                            >
                                <MenuItem key={0} value={'Todas'}>
                                    <Checkbox checked={selectedAllSedes.length === sedes.length} 
                                        style ={{
                                            color: "#FABB00",
                                        }} 
                                    />
                                    <ListItemText primary={"Todas"} />
                                </MenuItem>
                                {
                                    sedes.map((item:any) => (
                                        <MenuItem key={item.id} value={item.sedeName}>
                                            <Checkbox 
                                                checked={selectedAllSedes.indexOf(item.sedeName) > -1} 
                                                style ={{
                                                    color: "#FABB00",
                                                }}
                                            />
                                            <ListItemText primary={item.sedeName} />
                                        </MenuItem>
                                    ))
                                }                                           
                            </Select>
                            <FormHelperText style={{color: "red", width: '185px'}}>
                                {formik.touched.sede && formik.errors.sede}
                            </FormHelperText>
                        </FormControl>

                        <FormControl
                            fullWidth
                            size="small"
                            variant="outlined"
                            className="question"
                            error={formik.touched.area && Boolean(formik.errors.area)}
                            style={{ minWidth: "48%", maxWidth: "120px" }}
                        >
                            <InputLabel id="demo-simple-select-label"
                                style={{ backgroundColor: "#FFFFFF", width: "124px", zIndex: 0 }}
                            >&Aacute;rea o Proyecto*</InputLabel>
                            <Select
                                style={{
                                    fontFamily: 'Roboto',
                                    fontStyle: 'italic',
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    //width:"212px",
                                    height: "40px"
                                }}
                                label={'Área o Proyecto'}
                                value={selectedAllProjects}
                                onChange={
                                    (e) => {
                                        formik.handleChange(e);
                                        onChangeProject(e);
                                    }
                                }
                                labelId="demo-simple-select-label"
                                id="area"
                                name="area"
                                multiple
                                renderValue={(selected: any) => selected.join(',')}
                                error={formik.touched.area && Boolean(formik.errors.area)}
                            >
                                <MenuItem key={0} value={'Todas'}>
                                    <Checkbox
                                        checked={selectedAllProjects.length === projects.length}
                                        style={{
                                            color: "#FABB00",
                                        }}
                                    />
                                    <ListItemText primary={"Todas"} />
                                </MenuItem>
                                {
                                    projects.map((project: any) => (
                                        <MenuItem key={project.id} value={project.proyectNameAndClient}>
                                            <Checkbox checked={selectedAllProjects.indexOf(project.proyectNameAndClient) > -1} style={{
                                                color: "#FABB00",
                                            }} />
                                            <ListItemText primary={project.proyectNameAndClient} />
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText style={{ color: "red", width: '185px' }}>
                                {formik.touched.area && formik.errors.area}
                            </FormHelperText>
                        </FormControl>
                    </DialogContent>
                    <DialogContent>
                        <button className="btnAdminColaborador" type="button"
                            onClick={() => handleAdminColaborador()}     >
                            {`Administrar colaboradores (${selectedUser.length > 0 ? selectedUser.length:colaboradoresBD.length})`}
                        </button> 
                    </DialogContent>
                    <Fade
                        in={loadingFade}
                        style={{
                          transitionDelay: loadingFade ? '900ms' : '0ms',
                        }}
                        unmountOnExit >
                      <CircularProgress  />
                 </Fade>
                    <DialogContent>
                        <button
                            className="btnAddTemario"
                            type="button"
                            onClick={addTemarioField}
                        >
                            <div><span className="txtBttonTemario">Agregar temario</span></div>
                            <div><img src={Plus} alt="plus"/></div>
                        </button>
                    </DialogContent>
                    {temario.map((item, index) => (
                        <DialogContent key={index} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <TextField
                                label={`Temario ${index + 1}`}
                                variant="outlined"
                                size="small"
                                multiline
                                rows={2}
                                style={{ width: '80%' }}
                                value={item}
                                onChange={(e) => handleTemarioChange(index, e.target.value)}
                            />
                            <div className="iconoRestriccion" style={{ alignContent: 'center' }}
                                onClick={() => removeTemarioField(index)}
                            >
                                <img src={Minus} alt="minus" />
                            </div>
                        </DialogContent>
                    ))}
                    <DialogContent>
                        <TextField
                            id="outlined-multiline-static"
                            label="Descripción"
                            multiline
                            name="description"
                            rows={4}
                            variant="outlined"
                            inputProps={{ maxLength: 300}}
                            style={{ width: "100%", fontFamily:'Roboto',fontStyle: 'italic'}}
                            value={formik.values.description}
                            onChange={(e: any) => {
                                formik.handleChange(e);
                                counterCaracter(e.target.value);
                            }}
                            onBlur={formik.handleBlur}
                            InputLabelProps={{
                                style: { zIndex: 0 }
                            }}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        />
                        <div className="divCounterCaracterCurso"><label className="txtConterDesc">{`${counterTxt}/300`}</label></div>
                    </DialogContent>
                    <DialogContent className='Pruebamodal'>
                        <FormControl
                            fullWidth
                            size="small"
                            variant="outlined"
                            className=""
                            style={{ width: "90%", maxWidth: "440px" }}
                            error={Boolean(formik.touched.competencias && formik.errors.competencias)}
                        >
                            <InputLabel
                                id="demo-simple-select-label"
                                style={{ backgroundColor: "#FFFFFF", width: "47%" }}
                            >
                                Agregar competencia *
                            </InputLabel>
                            <Select
                                style={{
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    width: '90%'
                                }}
                                id='competencias'
                                name='competencias'
                                labelId='demo-simple-select-label'
                                label={'Agregar competencia *'}
                                size='small'
                                value={formik.values.competencias}
                                //value={selectedCompetency || ''}
                                onChange={(e) => {formik.handleChange(e); setSelectedCompetency(e.target.value)}}
                            >
                                {
                                    filteredCompetencies.map((competence: any) => (
                                        <MenuItem key={competence.id} value={competence.id}>
                                            {competence.nameCompetence}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText>
                                {formik.touched.competencias && formik.errors.competencias && formik.errors.competencias}
                            </FormHelperText>
                        </FormControl>
                        <BtnAddCompetenciesCourse addCompetencie={addCompetency} disabled={isAddButtonDisabled} />
                    </DialogContent>
                    <DialogContent style={{ justifyContent: 'space-between', display: 'flex', padding: '12px 58px 0px 30px' }}>
                        <span className='calificacionMinima'>Competencias</span>
                    </DialogContent>
                    <DialogContent style={{ paddingTop: '10px' }}>
                        {
                            addCompetencias.map((competence: any) => (
                                <div key={competence.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '90%', paddingLeft: '9px', justifyContent: 'space-between' }}>
                                        <ul style={{ marginBottom: '7px' }}>{competence.nameCompetence}</ul>
                                        <div className="iconoRestriccion"
                                            onClick={() => removeCompetency(competence.id)}
                                        >
                                            <img src={Minus} alt="minus" />
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </DialogContent>
                    <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
                        <FormControl fullWidth size="small" variant="outlined" style={{ width: '40%'}}>
                            <div>
                                <Checkbox
                                    checked={evaluarCurso}
                                    onChange={(e) => setEvaluarCurso(e.target.checked)}
                                    color="primary"
                                />
                                <span> Evaluar Curso </span>
                            </div>
                        </FormControl>
                    </DialogContent>
                    <DialogContent className="twoBtnsCurso">
                        <div className="containerButtons">
                            <div className="containerCancelCurso">
                                <button className="btnCancelarCurso"
                                type="button"
                                onClick={(()=>{
                                    closeModalEvalModel();
                                })}>
                                    Cancelar
                                </button>
                            </div>
                            <div className="containerAddCurso">
                                <button className="btnAddCurso"
                                type="submit"
                                disabled={btnDisable}
                                >
                                    <div className="infoBtnAddCurso">
                                        <div>
                                            <img src={Add} alt="Crear Curso"/>
                                        </div>
                                        <div>
                                            <span className="txtBtnAdd">
                                                Actualizar Curso
                                            </span>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </DialogContent>
                </Form> 
            </DialogContent>
        </Dialog>

        {usersByCampusProject.length>0?                          
            <AdminColaboradoresCourses 
            users={usersByCampusProject}
            userSelect={selectedUser}
            setSelectedUser={setSelectedUser}
            colaboradoresBD={colaboradoresBD}
            /> :<></>
        }
        </>
        }
        </>
    )
}

export default UpdateCourse;